import React from 'react';
import { Box, ShimmerBox } from '@common-fe/common-fe';

import ReportSummaryBaseTable from './ReportSummaryBaseTable';
interface Props {
  isSmallMode?: boolean;
}
const ReportSummaryBaseLoading: React.FC<Props> = ({ isSmallMode }) => {
  return (
    <Box data-testid="report-summary_loading">
      <ShimmerBox width="150px" margin={{ vertical: 'spacing8' }} round="snackbarRound" height="24px" />

      <ReportSummaryBaseTable
        headers={[
          {
            value: (
              <ShimmerBox
                width="100px"
                margin={{ vertical: 'spacing8' }}
                round="snackbarRound"
                height="24px"
              />
            ),
          },
          {
            value: (
              <ShimmerBox
                width="130px"
                margin={{ vertical: 'spacing8' }}
                round="snackbarRound"
                height="24px"
              />
            ),
          },

          ...(isSmallMode
            ? []
            : [
                {
                  value: (
                    <ShimmerBox
                      width="150px"
                      margin={{ vertical: 'spacing8' }}
                      round="snackbarRound"
                      height="24px"
                    />
                  ),
                },
                {
                  value: (
                    <ShimmerBox
                      width="180px"
                      margin={{ vertical: 'spacing8' }}
                      round="snackbarRound"
                      height="24px"
                    />
                  ),
                },
              ]),
        ]}
        rows={[
          [
            {
              value: (
                <ShimmerBox
                  width="100px"
                  margin={{ vertical: 'spacing8' }}
                  round="snackbarRound"
                  height="24px"
                />
              ),
            },
            {
              value: (
                <ShimmerBox
                  width="130px"
                  margin={{ vertical: 'spacing8' }}
                  round="snackbarRound"
                  height="24px"
                />
              ),
            },

            ...(isSmallMode
              ? []
              : [
                  {
                    value: (
                      <ShimmerBox
                        width="150px"
                        margin={{ vertical: 'spacing8' }}
                        round="snackbarRound"
                        height="24px"
                      />
                    ),
                  },
                  {
                    value: (
                      <ShimmerBox
                        width="180px"
                        margin={{ vertical: 'spacing8' }}
                        round="snackbarRound"
                        height="24px"
                      />
                    ),
                  },
                ]),
          ],
          [
            {
              value: (
                <ShimmerBox
                  width="100px"
                  margin={{ vertical: 'spacing8' }}
                  round="snackbarRound"
                  height="24px"
                />
              ),
            },
            {
              value: (
                <ShimmerBox
                  width="130px"
                  margin={{ vertical: 'spacing8' }}
                  round="snackbarRound"
                  height="24px"
                />
              ),
            },
            ...(isSmallMode
              ? []
              : [
                  {
                    value: (
                      <ShimmerBox
                        width="150px"
                        margin={{ vertical: 'spacing8' }}
                        round="snackbarRound"
                        height="24px"
                      />
                    ),
                  },
                  {
                    value: (
                      <ShimmerBox
                        width="180px"
                        margin={{ vertical: 'spacing8' }}
                        round="snackbarRound"
                        height="24px"
                      />
                    ),
                  },
                ]),
          ],
        ]}
        key="preloader"
      />
    </Box>
  );
};

export default ReportSummaryBaseLoading;
